import { useTranslations } from "use-intl";
import { StarIcon } from "@phosphor-icons/react";

import type { FlightFormLocation } from "@/app/lib/types/types";
import { SearchResultList, SearchResultButton } from "./SearchResultList";

type Props = {
  topLocations: FlightFormLocation[];
  onClick: (location: FlightFormLocation) => void;
};

export function TopLocationList({ onClick, topLocations }: Props) {
  const t = useTranslations();

  return (
    <SearchResultList
      heading={t("topLocations")}
      data={topLocations}
      getItemKey={(location) => location.id}
      renderItem={(location) => {
        return (
          <SearchResultButton
            key={location.id}
            icon={StarIcon}
            primaryText={location.name}
            secondaryText={location.countryName}
            code={location.code}
            onClick={() => onClick(location)}
          />
        );
      }}
    />
  );
}
